import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './illustrations.css';
/**
 * The frame every illustration draws in. With a `title` it's a meaningful image (role="img",
 * named by the title); without one it's decoration, hidden from assistive tech.
 */ export function Art({ viewBox, title, className, children }) {
    const cls = className ? `mk-ill ${className}` : 'mk-ill';
    return title ? /*#__PURE__*/ _jsxs("svg", {
        viewBox: viewBox,
        className: cls,
        role: "img",
        "aria-label": title,
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: title
            }),
            children
        ]
    }) : /*#__PURE__*/ _jsx("svg", {
        viewBox: viewBox,
        className: cls,
        "aria-hidden": "true",
        focusable: "false",
        children: children
    });
}
/** A decorative spot between two sections, centred at the width it was drawn for. */ export function Spot({ width = 320, children }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "mk-spot",
        style: {
            ['--spot-w']: `${width}px`
        },
        children: children
    });
}
